module.exports = __webpack_public_path__ + "img/html5.f60a5182.png";